import React, { useEffect } from 'react';
import './FichaTecnica.css';

const WSP_DEFAULT = '5491140882236';

function wspUrl(telefono) {
  const num = (telefono || '').replace(/[^0-9]/g, '') || WSP_DEFAULT;
  return `https://wa.me/${num}?text=Hola%2C%20me%20interesa%20la%20m%C3%A1quina%20`;
}

function FichaTecnica({ producto, onClose }) {
  // imagenes: usa array si existe, sino imagen única
  const imagenes = producto.imagenes?.length ? producto.imagenes : [producto.imagen];
  const [imgIdx, setImgIdx] = React.useState(0);
  const [lightbox, setLightbox] = React.useState(false);

  useEffect(() => {
    const handler = (e) => {
      if (e.key === 'Escape') {
        if (lightbox) setLightbox(false);
        else onClose();
      }
      if (lightbox && e.key === 'ArrowRight') setImgIdx(i => (i + 1) % imagenes.length);
      if (lightbox && e.key === 'ArrowLeft') setImgIdx(i => (i - 1 + imagenes.length) % imagenes.length);
    };
    document.addEventListener('keydown', handler);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handler);
      document.body.style.overflow = '';
    };
  }, [onClose, lightbox, imagenes.length]);

  if (!producto) return null;

  const wspLink = wspUrl(producto.telefono) + encodeURIComponent(producto.nombre);
  const imgActual = imagenes[imgIdx];

  return (
    <div className="ficha-overlay" onClick={lightbox ? () => setLightbox(false) : onClose}>
      <div className="ficha-modal" onClick={e => e.stopPropagation()}>

        <button className="ficha-close" onClick={onClose} aria-label="Cerrar">✕</button>

        {/* ── HEADER ── */}
        <div className="ficha-header">
          <div className="ficha-logo-area">
            <img src="/assets/bh_logo.png" alt="BH La Marca del Panadero" className="ficha-logo" />
          </div>
          <div className="ficha-title-area">
            <span className="ficha-title-label">FICHA TÉCNICA</span>
            <div className="ficha-nombre-bar">
              <h1>{producto.nombre}</h1>
            </div>
          </div>
        </div>

        {/* ── IDENTIDAD ── */}
        <div className="ficha-identidad">
          <p><strong>Marca:</strong> BH – La Marca del Panadero</p>
          <p><strong>Modelo:</strong> {producto.modelo}</p>
          <p><strong>Tipo:</strong> {producto.tipo}</p>
        </div>

        {/* ── BODY ── */}
        <div className="ficha-body">
          <div className="ficha-col-left">

            <div className="ficha-section">
              <div className="ficha-section-header">Descripción general</div>
              <div className="ficha-section-body">
                <p>{producto.descripcion}</p>
              </div>
            </div>

            <div className="ficha-section">
              <div className="ficha-section-header">Especificaciones técnicas</div>
              <div className="ficha-section-body">
                <ul className="ficha-specs">
                  {producto.specs.map((spec, i) => (
                    <li key={i} className="ficha-spec-item">
                      <span className="ficha-spec-icon">{spec.icono}</span>
                      <span className="ficha-spec-text">
                        <strong>{spec.label}:</strong> {spec.valor}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <a href={wspLink} target="_blank" rel="noopener noreferrer" className="ficha-wsp-btn">
              <span>💬</span> CONSULTAR POR WHATSAPP
            </a>
          </div>

          {/* ── Columna imagen ── */}
          <div className="ficha-col-right">
            <div className="ficha-imagen-wrapper" onClick={() => setLightbox(true)}>
              <img src={imgActual} alt={producto.nombre} className="ficha-imagen" />
              <div className="ficha-imagen-zoom">🔍</div>
            </div>

            <p className="ficha-imagen-leyenda">Imagen ilustrativa</p>

            {/* Miniaturas si hay más de una foto */}
            {imagenes.length > 1 && (
              <div className="ficha-thumbs">
                {imagenes.map((img, i) => (
                  <div
                    key={i}
                    className={`ficha-thumb ${i === imgIdx ? 'active' : ''}`}
                    onClick={() => setImgIdx(i)}
                  >
                    <img src={img} alt={`${producto.nombre} ${i + 1}`} />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

      </div>

      {/* Lightbox */}
      {lightbox && (
        <div className="ficha-lightbox" onClick={() => setLightbox(false)}>
          <img src={imgActual} alt={producto.nombre} onClick={e => e.stopPropagation()} />
          {imagenes.length > 1 && (
            <>
              <button className="ficha-lightbox-nav prev" onClick={e => { e.stopPropagation(); setImgIdx(i => (i - 1 + imagenes.length) % imagenes.length); }}>‹</button>
              <button className="ficha-lightbox-nav next" onClick={e => { e.stopPropagation(); setImgIdx(i => (i + 1) % imagenes.length); }}>›</button>
              <span className="ficha-lightbox-counter">{imgIdx + 1} / {imagenes.length}</span>
            </>
          )}
          <button className="ficha-lightbox-close" onClick={() => setLightbox(false)}>✕</button>
        </div>
      )}
    </div>
  );
}

export default FichaTecnica;
